import braze from '~/services/braze.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  legacyId: string;
};

class UpdateNotificationEvent extends UserEvent<EventData> {
  sendToBraze(): void {
    return braze.logReminderEvent({
      itemId: this.data.legacyId ?? '',
      reminded: true
    });
  }
}

export default UpdateNotificationEvent;
